import { render, staticRenderFns } from "./OversoldView.vue?vue&type=template&id=f2528572&scoped=true"
import script from "./OversoldView.vue?vue&type=script&lang=js"
export * from "./OversoldView.vue?vue&type=script&lang=js"
import style0 from "./OversoldView.vue?vue&type=style&index=0&id=f2528572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2528572",
  null
  
)

export default component.exports